import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
  Injector,
} from '@angular/core';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { DataProcessingService } from 'app/pages/data-processing/data-processing.service';
import { PayrollsService } from '../../payrolls/payrolls.service';
import { ParentModule } from '../ParentClass/parent-module';
import { SweetAlertHelper } from '../../../core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-recalculate-button',
  templateUrl: './recalculate-button.component.html',
  styleUrls: ['./recalculate-button.component.scss'],
})
export class RecalculateButtonComponent extends ParentModule implements OnInit, OnChanges {
  @Input() trips: any[];
  @Input() calculateProvAmount: boolean;
  @Output() finish = new EventEmitter<any>();
  currentUser = JSON.parse(localStorage.getItem('currentUser'));
  enableButton = false;

  constructor(
    private loading: T2LoadingService,
    private service: DataProcessingService,
    protected servicePayrollsService: PayrollsService,
    protected Inject: Injector,
    private sweetAlertHelper: SweetAlertHelper,
  ) {
    super('app-recalculate-button', Inject);
  }

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.trips.length) {
      this.enableButton = false;
      this.loading.hiden();
    }
  }

  recalculate() {
    if (this.trips.length) {
      this.enableButton = true;

      let tripids = [];
      if (typeof this.trips[0] === 'object') {
        tripids = this.trips.map((el) => {
          return el.tripid;
        });
      }
      this.loading.show();
      if (this.calculateProvAmount) {
        this.servicePayrollsService.putRecalcProvamount(tripids).subscribe(
          (success) => {
            this.responService(success);
          },
          (error) => {
            this.responService(error);
          }
        );
      } else {
        this.service
          .providerAmount(tripids.length > 0 ? tripids : this.trips)
          .subscribe(
            (success) => {
              this.responService(success);
            },
            (error) => {
              this.responService(error);
            }
          );
      }
    } else {
      this.sweetAlertHelper.createCustomAlert({
        text: 'Select at least one row',
        type: 'warning'
      });
    }
  }

  get isEnableButton(): boolean {
    return this.trips.length === 0 || this.enableButton;
  }

  swal(resp) {
    return this.sweetAlertHelper.createCustomAlert({
      title: resp.success ? 'Success' : 'Error',
      text: resp.message,
      type: resp.success ? 'success' : 'error'
    })
  }

  responService(resp) {
    this.loading.hiden();
    if (resp.success) {
      this.swal(resp).then(() => {
        this.finish.emit();
      });
    } else {
      this.swal(resp).then(() => {
        this.finish.emit(resp);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/recalculate-button/recalculate-button.component.ts